import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "./ProtectedRoute.css";

export default function ProtectedRoute({ children }) {
  const { auth, loading } = useAuth();

  if (loading) {
    return <div className="protected-route-loading">Loading...</div>;
  }

  if (!auth?.token) {
    return <Navigate to="/login" />;
  }

  return children;
}
